module.exports = __webpack_public_path__ + "img/TruPath-8.690af263.jpg";